export type CargoInsuranceProviderError = {
  message?: string;
  errorCode?: string;
  severity: 'warn' | 'error';
};

export class CargoInsuranceBadRequestResponse {
  cargoInsuranceProviderWarnings: CargoInsuranceProviderError[] = [];
  cargoInsuranceProviderErrors: CargoInsuranceProviderError[] = [];

  customMessageByErrorCode = new Map([
    [
      'KYCERR',
      'This quote requires additional screening. Verify that the shipper, consignee, assured name, and contact information are accurate and contain no unnecessary acronyms. Correct any errors and then re-submit the request. If you can’t find any errors, please contact us.',
    ],
  ]);

  constructor(opts?: Partial<CargoInsuranceBadRequestResponse>) {
    if (opts?.cargoInsuranceProviderWarnings) {
      this.cargoInsuranceProviderWarnings =
        opts.cargoInsuranceProviderWarnings.map(
          (error: Partial<CargoInsuranceProviderError>) => ({
            message: this.getMessage(error.errorCode, error.message),
            errorCode: error.errorCode,
            severity: 'warn',
          }),
        );
    }

    if (opts?.cargoInsuranceProviderErrors) {
      this.cargoInsuranceProviderErrors = opts.cargoInsuranceProviderErrors.map(
        (error: Partial<CargoInsuranceProviderError>) => ({
          message: this.getMessage(error.errorCode, error.message),
          errorCode: error.errorCode,
          severity: 'error',
        }),
      );
    }
  }

  get allMessages(): CargoInsuranceProviderError[] {
    return [
      ...this.cargoInsuranceProviderWarnings,
      ...this.cargoInsuranceProviderErrors,
    ];
  }

  getMessage(code?: string, message?: string) {
    // Insert zero-width spaces (\u200B) after semicolons to allow line-breaking
    const parsedMessage = message?.replaceAll(';', ';\u200B');
    if (!code) {
      return parsedMessage;
    }

    return this.customMessageByErrorCode.get(code) ?? parsedMessage;
  }
}
